var map = {
	"./CSS.png": 228,
	"./CodingLab.png": 229,
	"./HTML.png": 230,
	"./HTML_JS_CSS.png": 231,
	"./Hopscotch.png": 232,
	"./JS.png": 233,
	"./LegoWedo.png": 234,
	"./MicroBit.png": 235,
	"./Python.png": 236,
	"./Scratch.png": 237,
	"./ScratchJr.png": 238,
	"./SpheroEdu.png": 239,
	"./Tynker.png": 240,
	"./TynkerJr.png": 241,
	"./WonderBlockly.png": 242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;